import { SelectedTranslatedTrack } from "providers/AudioProvider/types";

interface checkSelectedTracksProps {
    selectedTranslatedTrackIds: SelectedTranslatedTrack[];
    ind: number;
}
export const checkSelectedTracks = ({
    selectedTranslatedTrackIds,
    ind,
}: checkSelectedTracksProps) => {
    let modalText = "";
    if (selectedTranslatedTrackIds.length) {
        if (!selectedTranslatedTrackIds.find((item) => item.ind === ind)) {
            modalText = "for group movement you need to select this track";
            return modalText;
        }
        let prevInd = selectedTranslatedTrackIds[0].ind;
        for (let i = 1; i < selectedTranslatedTrackIds.length; i++) {
            if (selectedTranslatedTrackIds[i].ind - prevInd > 1) {
                modalText = "tracks must be selected sequentially";
                break;
            } else {
                prevInd = selectedTranslatedTrackIds[i].ind;
            }
        }
    }
    return modalText;
};

/**
 * Сдвинулась ли озвучка за время перетаскивания — положение или длина, в миллисекундах.
 *
 * Конец перетаскивания раньше сравнивал последнюю координату указателя (пиксели) с началом
 * реплики (миллисекунды): числа не совпадали никогда, и простое нажатие на ручку без движения
 * сохраняло реплику и запускало раздвижку соседей. Меньше полумиллисекунды — шум дробей, не
 * перемещение.
 */
export const voicingWasMoved = ({
    position,
    start,
    lengthPosition,
    length,
}: {
    position: number;
    start: number;
    lengthPosition: number;
    length: number;
}) => Math.abs(position - start) >= 0.5 || Math.abs(lengthPosition - length) >= 0.5;

/**
 * «Без автоправок»: как показать хвост озвучки, заходящий на следующую (хоть на 1 мс —
 * `manual_overlap_ms`, см. providers/AudioProvider/manualOverlaps). Такой наезд лежит в файлах
 * с загрузки — загрузка ничего не двигает и не сохраняет. Наложений не бывает и в этом режиме
 * (правило владельца 01.10.2026): следующая правка в папке отодвинет следующую озвучку позже —
 * на конец этой + 50 мс (так пишут в json раздвижка редактора и проход сервера), а размещение
 * сборки ставит её звук ровно на конец этой, без +50. Переводчик видит это на ленте заранее: низ
 * озвучки (лента вертикальная) закрашен красным на высоту наезда, а подсказка называет
 * миллисекунды и что будет. Без режима или без наезда — null, и дорожка выглядит как раньше.
 */
export const manualOverlapLook = ({
    manualOnly,
    overlapMs,
    lengthMs,
    zoomLevel,
    en,
}: {
    manualOnly: boolean;
    overlapMs: number | null | undefined;
    lengthMs: number;
    zoomLevel: number;
    en: boolean;
}): { shadow: string; hint: string } | null => {
    if (!manualOnly || !overlapMs || overlapMs <= 0) return null;
    const px = Math.round(Math.min(overlapMs, lengthMs) / zoomLevel);
    return {
        shadow: `inset 0 -${px}px 0 0 rgba(255, 0, 0, 0.75)`,
        hint: en
            ? `The tail of this voicing runs ${overlapMs} ms over the next one. Overlaps are removed even with no automatic edits: your next edit in this folder will push the next voicing later, to this one's end + 50 ms, and the build places its sound right at this one's end — nothing moves earlier, speed is not fitted. To place it yourself, move or shorten one of them.`
            : `Хвост этой озвучки заходит на следующую на ${overlapMs} мс. Наложения снимаются и без автоправок: следующая правка в этой папке отодвинет следующую озвучку позже — на конец этой + 50 мс, а сборка ставит её звук ровно на конец этой; раньше ничего не сдвигается, скорость не подгоняется. Чтобы поставить самим — отодвиньте или укоротите одну из них.`,
    };
};
